import { render, staticRenderFns } from "./ProgresSlider.vue?vue&type=template&id=a6eef32a&scoped=true&lang=pug"
import script from "./ProgresSlider.vue?vue&type=script&lang=js"
export * from "./ProgresSlider.vue?vue&type=script&lang=js"
import style0 from "./ProgresSlider.vue?vue&type=style&index=0&id=a6eef32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6eef32a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
